// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"59c526c4","283":"98fc115f","453":"560fda9e","474":"750aab8b","636":"46b25aaf","768":"45ec9596","832":"6500afe6","901":"621e40de"}[chunkId] + ".chunk.js";
};